var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/current_location.6b6daca2.png","uri@2x": __webpack_public_path__ + "static/media/current_location.0d40c802.png","uri@3x": __webpack_public_path__ + "static/media/current_location.b8a08cc8.png",
    width: 10,
    height: 15
});